var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"modal"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])]),_c('div',{staticClass:"btn-close",on:{"click":_vm.close}})])
}
var staticRenderFns = []

export { render, staticRenderFns }